module.exports = __webpack_public_path__ + "static/media/pencil.a503a79f.svg";